const originalError = console.error;

console.error = (...args) => {
    const message = args.join(' ');
    if (
        message.includes('Warning: ') &&
        message.includes('defaultProps') &&
        (message.includes('Sketch') || message.includes('Checkboard'))
    ) {
        return;
    }
    originalError.apply(console, args);
}; 